import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { FeatureFlag } from "./types";

export const FEATURE_FLAGS_LIST_QUERY_KEY = ["admin", "feature-flags"] as const;

// Hand-written fetch — see CLAUDE.md → TD-07 for why we bypass the
// Orval-generated client and call `httpClient` directly.
async function fetchFeatureFlags(): Promise<readonly FeatureFlag[]> {
  return httpClient<readonly FeatureFlag[]>("/api/admin/feature-flags");
}

export function useFeatureFlagsList() {
  return useQuery({
    queryKey: FEATURE_FLAGS_LIST_QUERY_KEY,
    queryFn: fetchFeatureFlags,
    staleTime: 60_000,
  });
}
